import { useContext, useRef, useState } from "react";
import Button from "../../components/Button/Button";
import Menu from "../../components/Menu/Menu";
import './Login.scss';
import api from "../../js/api";
import { useNavigate } from "react-router-dom";
import { hasRole } from "../../js/utils";
import { UserContext } from "../../js/UserContext";

export default function Login() {
    const navigate = useNavigate();
    const [login, setLogin] = useState(null);
    const [email, setEmail] = useState(null);
    const [password, setPassword] = useState(null);
    const [isLogin, setIsLogin] = useState(true);
    const { user, loafing } = useContext(UserContext);
    const passwordRef = useRef(null);

    const loginFunc = async () => {
        const response = await api.post(`/login/` + login, { password });
        if (!response || !response.token) {
            return;
        }

        localStorage.setItem('token', response.token);
        api.setToken(response.token);
        window.location.href = '/profile';
    }

    const buttons = {
        login:
            <Button text="Login" onClick={async (e) => {
                e.preventDefault();
                await loginFunc();
            }} />,
        register:
            <Button text="Register" onClick={(e) => {
                e.preventDefault();
                if (!hasRole(user, ['admin'])) {
                    return alert('temporarily disabled');
                }
                setIsLogin(!isLogin);
            }
            } />,
        submit:
            <Button text="Submit" onClick={async (e) => {
                e.preventDefault();
                if (!login) {
                    return alert('Login is required');
                }
                if (!password) {
                    return alert('Password is required');
                }
                // DELETEME
                if (!login.includes('test')) {
                    return alert(`Invalid login: "${login}"`);
                }

                const user = {
                    login: login,
                    password: password,
                    email: email
                }
                const response = await api.post('/user', user);
                if (!response) {
                    return alert('There was an error creating the account');
                }
                if (response.error) {
                    return alert('There was an error creating the account -> ' + response.error);
                }

                const token = await api.post('/login/' + login, { password });
                if (token.error) {
                    return alert('There was an error logging in -> ' + token.error);
                }

                console.log(`New token: ${token.token}`);

                localStorage.setItem('token', token.token);
                api.setToken(token.token);
                navigate('/');
            }
            } />,
        cancel:
            <Button text="Cancel" onClick={(e) => {
                e.preventDefault();
                setIsLogin(!isLogin);
            }
            } />
    }

    const inputs = {
        login: <input className="input login-input" type="text" placeholder="Username" onChange={(e) => {
            setLogin(e.target.value)
        }} onKeyDown={(e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                passwordRef.current?.focus();
            }
        }} />,
        email: <input className="input login-input" type="text" placeholder="Email (optional)" onChange={(e) => {
            setEmail(e.target.value)
        }} onKeyDown={(e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                passwordRef.current?.focus();
            }
        }} />,
        password: <input ref={passwordRef} className="input login-input" type="password" placeholder="Password" onChange={(e) => {
            setPassword(e.target.value)
        }} onKeyDown={(e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                loginFunc();
            }
        }} />,
    }

    return (
        <div id="login">
            <div className='centered-container'>
                <h1>Login</h1>
                <form>

                    {/* Inputs */}
                    {inputs.login}
                    {isLogin ? null : inputs.email}
                    {inputs.password}

                    {/* Buttons */}
                    {isLogin ? (
                        <>
                            {buttons.login}
                            {buttons.register}
                        </>
                    ) : (
                        <>
                            {buttons.submit}
                            {buttons.cancel}
                        </>
                    )}
                </form>
                <Menu title="" options={[
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>
        </div>
    );
}